import React, {useMemo, useState} from 'react';

import {useTranslation} from 'react-i18next';

import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Input} from 'components/ui-kit/Input';
import {Modal} from 'components/ui-kit/Modal';

import {ConfirmBlockMessage, ConfirmRemoveFooter} from './styled';

interface Props {
    isBlockModalVisible: boolean;
    setIsBlockModalVisible: (isBlockModalVisible: boolean) => void;
    onDeactivateStorage: (reason: string) => void;
    deactivatePending: boolean;
}

export const ConfirmBlockModal = ({
    isBlockModalVisible,
    setIsBlockModalVisible,
    onDeactivateStorage,
    deactivatePending,
}: Props) => {
    const {t} = useTranslation();
    const translate = (key: string) => t('pages.profile.storages.confirmBlock.' + key);

    const [reason, setReason] = useState('');
    const [showReason, setShowReason] = useState(false);

    const buttonText = useMemo(() => {
        if (showReason) {
            return translate('deactivate');
        }

        return translate('ok');
    }, [translate, t]);

    if (!isBlockModalVisible) return null;

    return (
        <Modal
            title={translate('title')}
            modalWidth={0}
            show={!!isBlockModalVisible}
            closable={true}
            onClose={() => setIsBlockModalVisible(false)}
        >
            <ConfirmBlockMessage>{translate('message')}</ConfirmBlockMessage>
            {showReason && (
                <Input
                    isRequired
                    type="text"
                    label={t('pages.profile.staff.confirmBlock.reason')}
                    placeholder={t('pages.profile.staff.confirmBlock.reasonPlaceholder')}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    style={{marginBottom: 10}}
                />
            )}
            <ConfirmRemoveFooter>
                <Button
                    isLoading={deactivatePending}
                    disabled={false}
                    type="button"
                    variant={ButtonVariant.Outline}
                    onClick={() => {
                        setIsBlockModalVisible(false);
                        setShowReason(false);
                    }}
                >
                    {translate('cancel')}
                </Button>
                <Button
                    isLoading={deactivatePending}
                    variant={ButtonVariant.Normal}
                    size="md"
                    type="button"
                    disabled={showReason && !reason}
                    onClick={() => {
                        if (showReason) {
                            onDeactivateStorage(reason);
                        } else {
                            setShowReason(true);
                        }
                    }}
                >
                    {buttonText}
                </Button>
            </ConfirmRemoveFooter>
        </Modal>
    );
};
